import { observable, computed, action, toJS } from 'mobx'
import { ICredit } from '../Model/Questionnaire'

export default class CreditsStore {
    public static getInstance(): CreditsStore {
        return this._instance || (this._instance = new this())
    }

    private static _instance: CreditsStore

    @observable
    private _item: ICredit | null

    @computed
    get getItem(): ICredit | null {
        return toJS(this._item)
    }

    @action.bound
    setItem(credit: ICredit | null): void {
        this._item = credit
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/CreditsStore.ts